import { MultiValuesNode, NodeWithGroupInfo, SingleValueNode } from '../../../types/chartDataTypes';
import { getBottomGroups, withGroupInfo } from '../../../shared/helper/chartDataHelper';

export type StackEntry = {
  name: string;
  groupNames: string[];
};

export type StackNode = SingleValueNode & {
  stack: number;
};

export type BarData = {
  stackEntries: StackEntry[][];
  years: SingleValueNode[];
};

export const mapBarData = (data: MultiValuesNode, keys: string[]): BarData => {
  const bottomGroups = data.entries.map((baseEntry) => (
    getBottomGroups(withGroupInfo(baseEntry))
  ));

  // We will stack the data by the first level
  // the levels below are flattened, so that only the leafs are not shown
  const stackEntries = bottomGroups.map((groups): StackEntry[] => (
    groups.map(
      (entry) => ({
        name: entry.name || entry.totalLabel,
        groupNames: (entry as NodeWithGroupInfo).groupNames,
      } as StackEntry),
    )
  ));

  const years: SingleValueNode[] = keys.map(
    (name): SingleValueNode => {
      const entries = bottomGroups.flatMap((groups, index) => (
        groups.map(
          (entry) => ({
            name: entry.name || entry.totalLabel,
            stack: index,
            value: entry.values[name],
          } as StackNode),
        )
      ));
      return { name, entries };
    },
  );

  return {
    stackEntries,
    years,
  } as BarData;
};
